var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-btn-container"},[_c('img',{staticClass:"img",attrs:{"src":require("@/assets/uploadd.svg")}}),_c('button',{staticClass:"upload-btn"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }